// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("Satoshi-Regular.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: '10Pixel';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
    font-weight: 1000;
    font-style: normal;
}

@font-face {
    font-family: '10Pixel';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
    font-weight: 2000;
    font-style: normal;
}

@font-face {
    font-family: '10Pixel';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
    font-weight: 3000;
    font-style: normal;
}`, "",{"version":3,"sources":["webpack://./src/Fonts/Fonts.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,+DAAkD;IAClD,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,+DAAkD;IAClD,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,+DAAkD;IAClD,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":["@font-face {\r\n    font-family: '10Pixel';\r\n    src: url('Satoshi-Regular.otf') format('opentype');\r\n    font-weight: 1000;\r\n    font-style: normal;\r\n}\r\n\r\n@font-face {\r\n    font-family: '10Pixel';\r\n    src: url('Satoshi-Regular.otf') format('opentype');\r\n    font-weight: 2000;\r\n    font-style: normal;\r\n}\r\n\r\n@font-face {\r\n    font-family: '10Pixel';\r\n    src: url('Satoshi-Regular.otf') format('opentype');\r\n    font-weight: 3000;\r\n    font-style: normal;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
